import { RadioButtonUnchecked as RadioButtonUncheckedIcon } from '@mui/icons-material';

const RadioButtonUnchecked = (): JSX.Element => <RadioButtonUncheckedIcon fontSize="inherit" />;

export default RadioButtonUnchecked;
